<template>
  <div class="header">
    <div class="inner">
      <div class="flexbetween">
        <div class="navigation-left btn-menu-bar" style="pointer-events: none;">
          <img src="static/images/icon/header/logo-s.png">
        </div>
        <div class="contentname lbold sp-top">
          {{ productInfo.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "simpleHeader",
  props: {
    productInfo: Object
  }
};
</script>

<style lang="scss">
@import "src/assets/style/header";
</style>



// WEBPACK FOOTER //
// Header.vue?4900d2bf